/**
 * @file Statistics.js
 * @desc header头部消息统计（目前只有法律垂类用）
 * @author baoleilei<baoleilei@baidu.com>
 */
'use strict';

export default {
    namespaced: true,
    state: {
        statistics: {
            del: 0,
            read: 0,
            total: 0,
            unread: 0,
            lawer_type: ''
        }
    },
    mutations: {

        /**
         * 设置统计信息
         *
         * @param {Object} state 状态树
         * @param {Object} info  统计信息
         */
        setStatistics(state, info) {
            state.statistics = info;
        }
    }
};
